<template>
  <div class="pay-trans-details">
    <div class="filter-section-container">
      <div class="filter-fixed">
        <span class="filter-fixed-title">{{ $t('data.filter_section') }}</span>
        <i
          class="el-icon-arrow-down filter-fixed-arrow"
          :class="{'fiter-icon-arrow-route':!showFilterContent}"
          @click="onClickFixedArrow"
        />
      </div>
      <el-collapse-transition>
        <div v-show="showFilterContent">
          <div id="filter-content" class="filter-content">
            <div class="filter-item">
              <div class="filter-item-label">{{ $t('merchantAccount.create_time') }}</div>
              <el-date-picker
                v-model="search.times"
                class="filter-item-value"
                size="small"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd HH:mm:ss"
                :default-time="['00:00:00','23:59:59']"
                type="daterange"
                range-separator="~"
                :start-placeholder="$t('components.start_date')"
                :end-placeholder="$t('components.end_date')"
              />
            </div>
            <div class="filter-item" :class="{'border-red':isShowBorderRed}">
              <div class="filter-item-label">
                {{ $t('merchantAccount.complete_time') }}
              </div>

              <el-date-picker
                v-model="search.response_times"
                class="filter-item-value"
                size="small"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd HH:mm:ss"
                :default-time="['00:00:00','23:59:59']"
                type="daterange"
                range-separator="~"
                :start-placeholder="$t('components.start_date')"
                :end-placeholder="$t('components.end_date')"
              />
            </div>

            <div class="filter-item">
              <div class="filter-item-label">
                {{ $t('merchant.merchant_name') }}
              </div>
              <SearchAgentSelect v-model="search.merchant_name" :only-name="true" style="width: 100%" />
            </div>

            <div class="filter-item">
              <div class="filter-item-label">{{ $t('merchantAccount.transaction_status') }}</div>
              <el-select v-model="search.transaction_status" class="filter-item-value" size="small" clearable>
                <el-option
                  v-for="(item,index) in payTransactionStatusArr"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </div>

<!--            <div class="filter-item">-->
<!--              <div class="filter-item-label">{{ $t('data.settlement_status') }}</div>-->
<!--              <el-select v-model="search.settlement_status" class="filter-item-value" size="small" clearable>-->
<!--                <el-option-->
<!--                  v-for="(item,index) in transactionSettlementStatusMap"-->
<!--                  :key="index"-->
<!--                  :label="item.label"-->
<!--                  :value="item.value"-->
<!--                />-->
<!--              </el-select>-->
<!--            </div>-->
            <div class="filter-item" />
            <div class="filter-item" />
            <div class="filter-item" />

          </div>
          <div class="filter-operate">

            <div class="filter-operate-right">
              <el-button class="search-btn mb-10" size="small" @click="onClickReset">{{ $t('components.clear') }}</el-button>
              <el-button class="search-btn mb-10" type="primary" size="small" icon="el-icon-search" @click="handleFilter">{{ $t('components.search') }}</el-button>
            </div>

          </div>
        </div>

      </el-collapse-transition>
    </div>
    <div class="total-container">
      <div class="total-item">
        {{ $t('data.total_count') }}: <span style="color:#3855F1;">{{ total_count }}</span>
      </div>
      <div class="total-item">
        {{ $t('data.total_amount') }}: <span style="color:#3855F1;">{{ $store.getters.currency }} {{ total_amount | toDivideWithDot }}</span>
      </div>
      <div class="total-item">
        {{ $t('data.total_commission') }}: <span style="color:#3855F1;">{{ $store.getters.currency }} {{ total_commission | toDivideWithDot }}</span>
      </div>
    </div>
    <div class="tableContainer">
      <!-- 列表 -->
      <el-table
        v-loading="listLoading"
        :data="tableData"
        stripe
        fit
        highlight-current-row
        style="width: 100%"
      >

        <el-table-column :label="$t('merchant.merchant_name')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.merchant_name }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('customerService.transaction_id')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.transaction_id }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('merchantAccount.merchant_order_id')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.merchant_order_id }}</span>
          </template>
        </el-table-column>

        <el-table-column min-width="110" :label="$t('merchant.payment_channel')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.channel_code }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('merchantAccount.transaction_status')" align="center" min-width="100px">
          <template slot-scope="scope">
            <div class="status-wrap">
              <el-tag class="tag-custom" :type="getPayTransStatusType(scope.row.transaction_status)">{{ getPayTransStatusLabel(scope.row.transaction_status) }}</el-tag>
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('merchantAccount.transaction_amount')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.transaction_amount | toDivideWithDot }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('data.commission')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.agent_commission | toDivideWithDot }}</span>
          </template>
        </el-table-column>

        <el-table-column min-width="110" :label="$t('merchantAccount.create_time')" align="center">
          <template slot-scope="scope">
            {{ scope.row.transaction_create_time }}
          </template>
        </el-table-column>

        <el-table-column min-width="110" :label="$t('merchantAccount.complete_time')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.transaction_return_time }}</span>
          </template>
        </el-table-column>

      </el-table>

      <div class="pagination-container">
        <paginator v-if="!listLoading" :list-query="listQuery" @paginator-change="onClickPaginator" />
      </div>
    </div>
  </div>
</template>

<script>

import { fetchPaymentDetailInfo } from '@/api/settlement/settlement'
import { fetchPageMethodChannelList } from '@/api/components/components'
import { payTransactionStatusMap, payTransactionTypeMap, payinPaymentMethodMap, transactionFeeMode } from '@/utils/maps'
import { transactionSettlementStatusMap } from '@/maps/status.js'
import { filterEmptyAttr } from '@/utils/common'
import { appointDate } from '@/utils/index.js'
import SearchAgentSelect from '@/components/SearchAgentSelect'

export default {
  name: 'Pay_Trans_Details',
  components: {
    Paginator: () => import('@/views/components/Paginator'),
    SearchAgentSelect
  },
  data() {
    return {
      showFilterContent: true,
      search: {
        transaction_status: null, // 交易状态,
        times: [appointDate(-3) + ' 00:00:00', appointDate() + ' 23:59:59'],
        response_times: [],
        merchant_name: null
      },
      paymentMethodArr: [
        { label: 'Bill Payment', value: 2 },
        { label: 'QR Code', value: 1 },
        { label: 'Bank Transfer', value: 3 }
      ],
      payinChannelList: [],
      tableData: [],
      total_amount: 0,
      total_commission: 0,
      total_count: 0,
      listLoading: false,
      listQuery: {
        page: 1,
        limit: 15,
        total: 0
      },
      detailId: '',
      downloading: false,
      isShowBorderRed: false
    }
  },
  computed: {
    compIsJTMerchant() {
      return this.$store.state.user.isJTMerchant
    },
    getTansationFeeModeLabel() {
      return function(value) {
        return transactionFeeMode(value).label
      }
    },
    payTransactionStatusArr() {
      const list = payTransactionStatusMap()
      const newList = list.filter(item => ![1, 3].includes(item.value))
      return list
    },
    compFilterPaymentChannel() {
      if (!this.search.pay_product_type) {
        return this.payinChannelList
      }
      const arr = this.payinChannelList.filter(item => item.payment_method === this.search.pay_product_type)
      return arr
    },
    getPayTransStatusType() {
      return function(value) {
        return payTransactionStatusMap(value).type
      }
    },
    getPayTransStatusLabel() {
      return function(value) {
        return payTransactionStatusMap(value).label
      }
    },
    getPayTransTypeMap() {
      return function(val) {
        return payTransactionTypeMap(val).label
      }
    },
    getPayTransTypeStyle() {
      return function(val) {
        return payTransactionTypeMap(val).type
      }
    },
    payinPaymentMethodMap() {
      let list = payinPaymentMethodMap()
      list = list.filter(item => {
        if (item.type === 'hide') {
          return false
        }
        return true
      })
      return list
    },
    getPayinPaymentMethodMap() {
      return function(value) {
        return payinPaymentMethodMap(value).label
      }
    },
    transactionSettlementStatusMap() {
      return transactionSettlementStatusMap()
    }
  },
  created() {
    // this.getAllChannelList()
    this.handleFilter()
  },
  methods: {
    getAllChannelList() {
      fetchPageMethodChannelList().then(res => {
        if (res.code === 10000) {
          this.payinChannelList = res.data || []
        }
      })
    },
    getPaymentDetailInfo(params) {
      this.listLoading = true
      fetchPaymentDetailInfo(params).then(res => {
        if (res.code === 10000) {
          const { total = 0, list = [], total_amount, total_commission } = res.data || {}
          this.listQuery.total = total
          this.listQuery.page = params.page ? params.page : 1
          this.tableData = list
          this.total_amount = total_amount
          this.total_commission = total_commission
          this.total_count = total
        }
      }).finally(() => {
        this.listLoading = false
      })
    },
    getParams(otherParams = {}) {
      const { transaction_status, times = [], response_times = [], ...otherSearch } = this.search
      // if (!response_times || response_times && !response_times[0]) {
      //   this.$message.warning('Tne Time is required!')
      //   return
      // }
      let params = {
        start_date_time: times && times[0],
        end_date_time: times && times[1],
        response_start_date_time: response_times && response_times[0],
        response_end_date_time: response_times && response_times[1],
        transaction_status,
        ...otherSearch,
        ...otherParams
      }

      params = filterEmptyAttr(params)
      return params
    },

    handleFilter(otherParams = {}) {
      if (!this.$commonFn.checkSubmitDateLimit(this.search.times, 15)) {
        this.$message.warning('The maximum date range  is limited to 15 days, please select again')
        return
      }
      if (!this.$commonFn.checkSubmitDateLimit(this.search.response_times, 15)) {
        this.$message.warning('The maximum date range  is limited to 15 days, please select again')
        return
      }
      const params = this.getParams(otherParams)
      if (!params) {
        return
      }
      this.getPaymentDetailInfo(params)
    },

    onClickFixedArrow() {
      this.showFilterContent = !this.showFilterContent
    },
    onClickReset() {
      this.search = {}
    },

    onClickPaginator() {
      this.handleFilter(this.listQuery)
    }
  }
}
</script>

<style lang="scss" scoped>
.icon-warning-outline{
  position: relative;
  top: 2px;
  color:  #4B5567;
  font-size: 16px;
}
.pay-trans-details{
  .transTime{
    display: inline-block;
    padding: 0 20px 10px 0;
    font-size: 14px;
    font-weight: 500;  font-family: 'Inter-Medium';
    color: #606266;
  }
  .filter-container{
    padding: 20px 0 0 20px;
  }
  .search-frame {
    width: 230px;
    margin-right: 5px;
  }
  .search-frame-order{
    width:200px;
  }
  .search-btn {
    margin-right: 10px;
  }
  .download-btn{
    margin: 0;
  }
  .picker{
    width: 230px
  }
  .mb-10{
    margin-bottom: 10px;
  }
  .detailTxt{
    font-size: 12px;
    color: #3579FF;
    text-decoration: underline;
     cursor: pointer;
  }
  .total-container{
    display: flex;
    border: 1px solid #D3D7DF;
    margin-bottom: 32px;
    .total-item{
      padding: 10px 0;
      flex: 1;
      text-align: center;
      border-right: 1px solid #D3D7DF;
      font-weight: 400;
      font-size: 14px;
      color: #4B5567;
    }
    .total-item:not(:last-child){
      border-right: 1px solid #D3D7DF;
    }
  }
  .total{
    border-top: 1px solid #D5D8DE;
    padding: 24px 24px 0 24px;
    &-title{
      font-size: 12px;
      line-height: 17px;
      color: #606266;
    }
    &-num{
      margin-top: 10px;
      padding-bottom: 20px;
      font-size: 16px;
      font-family: Source Han Sans SC;
      font-weight: bold;
      line-height: 24px;
      color: #303133;
    }
  }
}
.status-wrap {
  display: inline-block;
  position:relative;
  .status-tip-wrap {
    position:absolute;
    top:40%;
    transform:translateY(-50%);
    right:-20px;
  }
}
</style>
